import { render, staticRenderFns } from "./ListCentrosCustos.vue?vue&type=template&id=2b499a52&"
import script from "./ListCentrosCustos.vue?vue&type=script&lang=js&"
export * from "./ListCentrosCustos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports